<template>
    <div class="content-body" style="padding-top: 6rem">
        <div class="container-fluid">
            <!-- <div class="page-titles">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Info</a></li>
          <li class="breadcrumb-item">
            <a href="javascript:void(0)">{{ currentRouteName }}</a>
          </li>
        </ol>
      </div> -->

            <!-- Button Add -->
            <router-link :to="{ name: 'Tambah Knowledge' }" class="btn btn-primary mb-4">Tambah</router-link>
            <!-- Tutup -->

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="form-group">
                                <h4 class="card-title mb-3">Cari Data {{ currentRouteName }}</h4>
                                <p class="text-muted">Total Articles: {{ filteredCount }}</p>
                                <!-- Search bar -->
                                <div class="d-flex align-items-center">
                                    <input v-model="searchQuery" @input="handleSearch" class="form-control mr-3" placeholder="Search..." style="border-radius: 8px; width: 250px" />

                                    <!-- Filter Dropdown -->
                                    <div class="dropdown mr-3">
                                        <button
                                            class="btn btn-outline-primary"
                                            type="button"
                                            id="filterDropdown"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            style="border-radius: 8px; display: flex; align-items: center; gap: 5px">
                                            <i class="fa fa-filter"></i>
                                            Filter
                                        </button>
                                        <div class="dropdown-menu p-3" aria-labelledby="filterDropdown" style="width: 300px">
                                            <h6 class="dropdown-header">Add Filter</h6>
                                            <div class="d-flex flex-wrap">
                                                <!-- Month Filter -->
                                                <div class="filter-option" style="width: 100%" @click.stop>
                                                    <label for="monthFilter" class="filter-label">Month</label>
                                                    <select v-model="selectedMonth" id="monthFilter" class="form-control">
                                                        <option value="">Select Month</option>
                                                        <option v-for="month in months" :key="month.value" :value="month.value">
                                                            {{ month.text }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <!-- Year Filter -->
                                                <div class="filter-option" style="width: 100%" @click.stop>
                                                    <label for="yearFilter" class="filter-label">Year</label>
                                                    <select v-model="selectedYear" id="yearFilter" class="form-control">
                                                        <option value="">Select Year</option>
                                                        <option v-for="year in years" :key="year" :value="year">
                                                            {{ year }}
                                                        </option>
                                                    </select>
                                                </div>

                                                <!-- Sort Order Filter -->
                                                <div class="filter-option" style="width: 100%" @click.stop>
                                                    <label for="sortFilter" class="filter-label">Sort</label>
                                                    <select v-model="sortOrder" id="sortFilter" class="form-control">
                                                        <option value="desc">Descending</option>
                                                        <option value="asc">Ascending</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Reset Button -->
                                    <button @click="resetFilters" class="btn btn-link">Reset</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <!-- <table class="table header-border table-responsive-sm"> -->
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Icon</th>
                                            <th>Judul</th>
                                            <!-- <th>Kategori</th> -->
                                            <!-- <th>Deskripsi</th> -->
                                            <th>Thumbnail</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="!paginatedData.length" class="text-center">
                                            <td colspan="7">No Data</td>
                                        </tr>
                                        <tr v-for="(item, index) in paginatedData" :key="item.id">
                                            <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                            <td>
                                                <img :src="getImageUrlIcon(item)" alt="Preview" style="width: 120px; height: 70px; object-fit: cover; border-radius: 10px" />
                                            </td>
                                            <td>{{ item.title }}</td>
                                            <!-- <td>{{ item.kategori }}</td> -->

                                            <!-- <td v-html="truncateText(item.deskripsi, 50)"></td> -->
                                            <td>
                                                <img :src="getImageUrl(item)" alt="Preview" style="width: 120px; height: 70px; object-fit: cover; border-radius: 10px" />
                                            </td>
                                            <td>{{ item.is_publish ? "Publish" : "No" }}</td>
                                            <td>
                                                <router-link
                                                    :to="{
                                                        name: 'Edit Knowledge',
                                                        params: { id: item.id },
                                                    }"
                                                    class="btn btn-primary btn-rounded btn-xxs mr-1 mb-1">
                                                    <i class="fa fa-pencil color-muted"></i>
                                                </router-link>
                                                <button type="button" class="btn btn-dark btn-rounded btn-xxs mr-1 mb-1" @click="deleteKnowledge(item.id)">
                                                    <i class="fa fa-trash color-muted"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- Pagination -->
                            <nav>
                                <ul class="pagination justify-content-center">
                                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                        <a class="page-link" href="javascript:void(0)" @click="prevPage">Previous</a>
                                    </li>
                                    <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
                                        <a class="page-link" href="javascript:void(0)" @click="goToPage(page)">
                                            {{ page }}
                                        </a>
                                    </li>
                                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                        <a class="page-link" href="javascript:void(0)" @click="nextPage">Next</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Swal from "sweetalert2";
import axiosInstance from "../axios";
import defaultURL from "@/config";

export default {
    name: "Knowledge",

    setup() {
        const store = useStore();
        const router = useRoute();
        const currentRouteName = computed(() => router.name);
        const message = ref("You are not logged in!");
        const id_kategori = 17;
        const Knowledge = ref([]);

        const currentPage = ref(1);
        const perPage = 10;
        const searchQuery = ref("");
        const totalItems = ref(0);

        const filteredCount = computed(() => filteredData.value.length);

        const selectedMonth = ref("");
        const selectedYear = ref("");
        const sortOrder = ref("desc");
        const resetFilters = () => {
            searchQuery.value = "";
            selectedMonth.value = "";
            selectedYear.value = "";
            sortOrder.value = "desc";
            handleSearch(); // Refresh data if needed
        };

        // Generate months dynamically
        const months = Array.from({ length: 12 }, (v, i) => ({
            value: (i + 1).toString().padStart(2, "0"),
            text: new Date(0, i).toLocaleString("en", { month: "long" }),
        }));

        // Generate years dynamically based on the data or set a default range
        const currentYear = new Date().getFullYear();
        const years = computed(() => {
            const minYear = 2024; // set the start year as per your requirement or data availability
            return Array.from({ length: currentYear - minYear + 1 }, (v, i) => currentYear - i);
        });

        const getImageUrlIcon = (item) => {
            if (item) {
                return `${defaultURL}/images/blogs/icon/${item?.icon}`;
            }
            return "";
        };

        const getImageUrl = (item) => {
            if (item) {
                return `${defaultURL}/images/blogs/${item?.image}`;
            }
            return "";
        };

        const isAuthenticated = computed(() => store.getters.isAuthenticated);
        const token = computed(() => store.getters.token);
        const tokenExpiry = computed(() => store.getters.tokenExpiry);

        if (!token.value || !tokenExpiry.value || new Date() > new Date(tokenExpiry.value) || !isAuthenticated.value) {
            Swal.fire({
                title: "Error",
                text: `Session expired or invalid`,
                icon: "error",
                confirmButtonText: "OK",
            }).then(() => {
                store.dispatch("setAuth", false);
                store.dispatch("setToken", { token: null, expiry: null });
                localStorage.clear();
                window.location.href = "/";
            });
            return;
        }

        const fetchData = async () => {
            try {
                const getData = await axiosInstance.get(`/blog-kategori/${id_kategori}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token.value}`,
                    },
                });

                if (getData.status === 200) {
                    const data = await getData.data;
                    if (data.code === 200) {
                        Knowledge.value = data.data;
                        totalItems.value = data.data.length;
                    }
                } else {
                    Swal.fire({
                        title: "Error",
                        text: `Error: ${data.message}`,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } catch (error) {
                await Swal.fire({
                    title: "Error",
                    text: `Error: ${error.message}`,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        };

        const filteredData = computed(() => {
            return Knowledge.value
                .filter((item) => {
                    const itemDate = new Date(item.created_date);
                    const itemMonth = itemDate.getMonth() + 1; // getMonth() is 0-indexed, so add 1
                    const itemYear = itemDate.getFullYear();

                    // Log month and year comparisons for debugging
                    console.log(`Filtering item with created_date: ${item.created_date}`);
                    console.log(`Selected Month: ${selectedMonth.value}, Item Month: ${itemMonth}`);
                    console.log(`Selected Year: ${selectedYear.value}, Item Year: ${itemYear}`);

                    // Compare month and year as numbers for consistency
                    return (
                        (!selectedMonth.value || parseInt(selectedMonth.value) === itemMonth) &&
                        (!selectedYear.value || parseInt(selectedYear.value) === itemYear) &&
                        item.title.toLowerCase().includes(searchQuery.value.toLowerCase())
                    );
                })
                .sort((a, b) => {
                    if (sortOrder.value === "asc") return new Date(a.created_date) - new Date(b.created_date);
                    return new Date(b.created_date) - new Date(a.created_date);
                });
        });

        const paginatedData = computed(() => {
            const start = (currentPage.value - 1) * perPage;
            const end = start + perPage;
            return filteredData.value.slice(start, end);
        });

        const totalPages = computed(() => {
            return Math.ceil(filteredData.value.length / perPage);
        });

        const handleSearch = () => {
            currentPage.value = 1; // Reset to first page on search
        };

        const goToPage = (page) => {
            if (page >= 1 && page <= totalPages.value) {
                currentPage.value = page;
            }
        };

        const nextPage = () => {
            if (currentPage.value < totalPages.value) {
                currentPage.value++;
            }
        };

        const prevPage = () => {
            if (currentPage.value > 1) {
                currentPage.value--;
            }
        };

        const truncateText = (text, length) => {
            return text.length > length ? text.slice(0, length) + "..." : text;
        };

        const deleteKnowledge = async (id) => {
            try {
                const confirmation = await Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, cancel!",
                });

                if (confirmation.isConfirmed) {
                    const response = await axiosInstance.delete(`/blog/${id}`, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token.value}`,
                        },
                    });

                    if (response.status === 200) {
                        Swal.fire("Deleted!", "Your record has been deleted.", "success");
                        Knowledge.value = Knowledge.value.filter((item) => item.id !== id);
                    } else {
                        Swal.fire("Error!", "There was an issue deleting the record.", "error");
                    }
                }
            } catch (error) {
                Swal.fire("Error!", `Error: ${error.message}`, "error");
            }
        };

        onMounted(() => {
            fetchData();
        });

        return {
            currentRouteName,
            Knowledge,
            fetchData,
            searchQuery,
            handleSearch,
            paginatedData,
            currentPage,
            totalPages,
            goToPage,
            perPage,
            nextPage,
            prevPage,
            truncateText,
            deleteKnowledge,
            getImageUrlIcon,
            getImageUrl,
            months,
            years,
            selectedMonth,
            selectedYear,
            sortOrder,
            resetFilters,
            filteredCount,
        };
    },
};
</script>
